module.exports = __webpack_public_path__ + "assets/media/l-4.c9a7bb54.svg";